let types = {
    "warning": "warning",
    "alert": "alert",
    "success": "success",
    "info": "info",
}

let BaseInfoBoxsTable = {
    "invalidPassword": {
        title: 'Accesso Fallito',
        text: 'I dati di accesso inseriti non sono corretti.',
        type: types.alert,
        time: 5,
    },
    "alreadyLogged": {
        title: 'Pagina non disponibile',
        text: 'La pagina richiesta non è disponibile se sei già Loggato.',
        type: types.info,
        time: 5,
    },
    "notLogged": {
        title: 'Accesso Negato',
        text: 'Non sei Loggato con nessun account.<br>Assicurati di essere Loggato con l\'account corretto.',
        type: types.alert,
        time: 8,
    },
    "pageAccessDenied": {
        title: 'Accesso Negato',
        text: 'Non hai i permessi necessari a visualizzare la pagina richiesta.' +
            '<br>Assicurati di essere Loggato con l\'account corretto e di avere i permessi necessari.',
        type: types.alert,
        time: 8,
    },
    "emailVerified": {
        title: 'Email Verificata',
        text: 'Il tuo indirizzo email è stato verificato con successo!',
        type: types.success,
        time: 10,
    },
    "emailInvalidToken": {
        title: 'Errore durante la verifica',
        text: "C'è stato un errore durante la verifica dell'email.\n" +
            "Il token che hai usato non è valido.",
        type: types.alert,
        time: 10,
    },
    "emailInvalidScope": {
        title: 'Errore durante la verifica',
        text: "C'è stato un errore durante la verifica dell'email.\n" +
            "Il token che hai usato non è corretto per la verifica dell'email.",
        type: types.alert,
        time: 10,
    },
    "emailExpiredToken": {
        title: 'Errore durante la verifica',
        text: "Il Token che hai provato a utilizzare risulta scaduto.\n" +
            "Prova a richiederne uno nuovo. Se il problema persiste contatta il supporto.",
        type: types.alert,
        time: 10,
    }
}
const getBaseInfoBox = (id: any) => {
    // @ts-ignore
    let baseInfoBox = BaseInfoBoxsTable[id];

    let jsonString = JSON.stringify(baseInfoBox);

    return btoa(jsonString);
}

export default getBaseInfoBox;